<template>
  <v-container>
    <v-card
      class="align-center"
      max-width="450"
      min-width="450"
      height="100%"
      color="messageBubble"
      elevation="0"
    >
      <v-row justify="start" no-gutters dense>
        <v-col sm="6">
          <v-btn x-small outlined color="cleed_blue">
            <b>{{ message.message || "Looks" }}</b>
          </v-btn>
        </v-col>
      </v-row>
      <v-row dense justify="center" align="center" class="mt-1">
        <v-col cols="7" lg="7">
          <v-img :src="main_look" width="100%" aspect-ratio=".85" cover />
        </v-col>
      </v-row>
      <v-row
        dense
        class="ma-2 mb-4"
        justify="center"
        align="center"
        v-if="looks && looks.length"
      >
        <v-col v-for="(product, key) in looks" :key="key" cols="6" lg="6">
          <MsgProductCard :message="product" :look="true" />
        </v-col>
        <v-btn
          icon
          absolute
          right
          class="mt-2"
          bottom
          color="white"
          style="margin: 0px 58px -49px"
          :disabled="right"
          :dark="right"
          @click="next()"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
          icon
          absolute
          left
          bottom
          class="mt-2"
          color="white"
          style="margin: 0px 58px -49px"
          :disabled="left"
          :dark="left"
          @click="prev()"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-row>
      <v-row class="mb-2 text-center" justify="center" align="center" v-else>
        <v-col cols="12">
          <v-btn fab large disabled color="white" dark elevation="0">
            <v-icon> mdi-image-off </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12">
          <span class="black--text"><b>Warning no url</b> </span>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import MsgProductCard from "./Msg_product_card";

export default {
  name: "Chat_caosule",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    MsgProductCard,
  },
  data: () => ({
    looks: [],
    form: 0,
    to: 2,
    model: 0,
    left: false,
    right: false,
    name: "Products",
    temp: [],
    main_look:
      "https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg",
  }),
  created() {
    this.from = 0;
    this.to = 2;
    if (this.message.look.values.down) {
      this.temp = this.message.look.values.down.values;
      this.main_look = this.message.look.values.picture_url[0];
    } else if (this.message.look.already_explored) {
      this.check_product_byID(this.message.look.already_explored.product_ids);
      this.main_look = this.message.look.already_explored.picture_url;
    } else if (this.message.look.values.product_ids) {
      this.check_product_byID(this.message.look.values.product_ids);
      this.main_look = this.message.look.values.picture_url;
    }
    this.diplay_mutiple();
    if (this.from - 2 <= 0) this.left = true;
  },
  methods: {
    diplay_mutiple() {
      this.looks = [];
      for (let i = this.from; i < this.to; i++) {
        const element = this.temp[i];
        if (element) this.looks.push(element);
      }
      if (this.temp && this.temp.length <= 2) this.right = true;
    },
    check_product_byID(ids) {
      ids.map((r) => {
        if (this.$store.state.product.products[r])
          this.temp.push(this.$store.state.product.products[r]);
      });
    },
    next() {
      if (this.temp && this.to + 2 >= this.temp.length) this.right = true;
      this.from = this.to;
      this.to = this.from + 2;
      this.diplay_mutiple();
      this.left = false;
    },
    prev() {
      if (this.from - 2 <= 0) this.left = true;
      this.from = this.to - 4;
      this.to = this.from + 2;
      this.diplay_mutiple();
      this.right = false;
    },
  },
};
</script>
<style scoped></style>
